module.exports = "/_next/static/images/diversification-62970ed96f9a1c0ea0f579e823f601de.jpeg";